import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

import {__} from "~/ts/library/Translate";
import SideMenuButton from "~/operatorApplication/vue/dialogs/dialog/sidemenu/info/SideMenuButton.vue";
import {ref} from "vue";
import {OperatorAccountStore} from "~/operatorApplication/ts/store/OperatorAccountStore";
import CrossOperatorConversationConfigDialog
    from "~/operatorApplication/vue/dialogs/dialog/sidemenu/crossOperatorConversation/CrossOperatorConversationConfigDialog.vue";

import OperatorApplicationClientOpenApiModel = OperatorApplicationApi.OperatorApplicationClientOpenApiModel;
import OperatorMessageSetDialogStatusAssignedOpenApiModel = OperatorApplicationApi.OperatorMessageSetDialogStatusAssignedOpenApiModel;

const __default__ = {
    name: "StartCrossOperatorConversationButton"
}

export default /*@__PURE__*/_defineComponent({
  ...__default__,
  props: {
    userdata: {},
    buttonMinWidth: {}
  },
  setup(__props: any) {


let props = __props;


let startConversationDialog = ref<{
    visible: boolean,
    assigned: OperatorMessageSetDialogStatusAssignedOpenApiModel,
}>();

function showStartConversationDialog() {
    startConversationDialog.value = {
        visible: true,
        assigned: {
            groupIds: [],
            operatorLogins: [OperatorAccountStore.login.value]
        }
    };
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (!__props.userdata.crossOperatorConversationUsername)
      ? (_openBlock(), _createBlock(SideMenuButton, {
          key: 0,
          icon: "comments-question-check",
          descr: _unref(__)('Обсуждение'),
          tooltip: _unref(__)('Начать обсуждение'),
          "min-width": __props.buttonMinWidth,
          onClick: showStartConversationDialog
        }, null, 8, ["descr", "tooltip", "min-width"]))
      : _createCommentVNode("", true),
    (_unref(startConversationDialog)?.visible)
      ? (_openBlock(), _createBlock(CrossOperatorConversationConfigDialog, {
          key: 1,
          visible: _unref(startConversationDialog).visible,
          "onUpdate:visible": _cache[0] || (_cache[0] = ($event: any) => ((_unref(startConversationDialog).visible) = $event)),
          userdata: __props.userdata
        }, null, 8, ["visible", "userdata"]))
      : _createCommentVNode("", true)
  ], 64))
}
}

})